export default __webpack_public_path__ + "static/media/botte-foin-contact.d150c1eb.png";